<app-layout>

  <app-header></app-header>

  <div id="contents">

    <!-- breadcrumb -->
      <div class="breadcrumb_area">
        <ol class="breadcrumb_list" itemscope="itemscope" itemtype="http://schema.org/BreadcrumbList">
          <li class="breadcrumb_nav breadcrumb_nav1" itemprop="itemListElement" itemscope="itemscope" itemtype="http://schema.org/ListItem"> <a href="{{ appUrl }}/" itemprop="item"> <span class="breadcrumb_text" itemprop="name">{{ lang | i18nSelect: strings.breadcrumb.home }}</span> </a>
            <meta itemprop="position" content="1">
          </li>
          <ng-container *ngIf="sortBrandName">
            <li class="breadcrumb_nav breadcrumb_nav2" itemprop="itemListElement" itemscope="itemscope"
                itemtype="http://schema.org/ListItem">
              <span class="gt">&gt;</span>
              <a routerLink="/" itemprop="item">
                <span class="breadcrumb_text" itemprop="name">{{ lang | i18nSelect: strings.breadcrumb.carList }}</span>
              </a>
              <meta itemprop="position" content="2">
            </li>
            <li class="breadcrumb_nav"> <span class="gt">&gt;</span> <span class="thispage">{{ sortBrandName }}</span> </li>
          </ng-container>
          <ng-container *ngIf="!sortBrandName">
            <li class="breadcrumb_nav"> <span class="gt">&gt;</span> <span class="thispage">{{ lang | i18nSelect: strings.breadcrumb.carList }}</span> </li>
          </ng-container>
        </ol>
      </div>
      <!-- breadcrumb -->

      <ng-container *ngIf="(carCollection$ | async) as carCollection; else carListLoadingTemplate">
        <section>
          <div class="page_box carlist carlayoutlist" id="allstocklist">
            <div class="inner_contents_box inner_carlist">
              <div class="page_header txtalcenter">
                <div class="inner_page_header" data-aos="fade-down">
                  <h1 class="t_head">{{ pageTitle }}</h1>
                </div>
              </div>

              <app-car-sort
                *ngIf="brands$ | async as brands; else brandLoading"
                [brands]="brands"
                [carPagination]="carCollection.pagination"
                [isSortSelling]="isSortSelling"
                [sortBrandId]="sortBrandId"
              ></app-car-sort>
              <ng-template #brandLoading>
                <div class="skeleton_list_sort"></div>
              </ng-template>

              <div class="stocklist_contents">
                <div class="inner_stocklist_contents">
                  <ul class="flex_layout flex_wrap car_list">
                    <li *ngFor="let car of carCollection.items; trackBy: trackById">
                      <div class="car_box {{ getCarLabelClassName(car) }}" [ngClass]="{'photolabel': (car.inTransaction || car.sold || car.previousPrice || car.new)}">
                        <app-car-list-item [car]="car" [lang]="lang"></app-car-list-item>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <app-car-pagination
              [carPagination]="carCollection.pagination"
              [currentRouterLinkPath]="currentRouterLinkPath"
              [currentQueries]="currentQueries"
              [lang]="lang"
            ></app-car-pagination>

          </div>
        </section>
      </ng-container>

      <ng-template #carListLoadingTemplate>
        <div class="page_box carlist carlayoutlist" id="allstocklist">
          <div class="inner_contents_box inner_carlist">
            <div class="page_header txtalcenter">
              <div class="inner_page_header" data-aos="fade-down">
                <h1 class="t_head skeleton_title">{{ pageTitle }}</h1>
              </div>
            </div>
            <div class="stocklist_contents">
              <div class="inner_stocklist_contents">
                <div class="fetch_loading">
                  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                  <ul class="flex_layout flex_wrap skeleton_box">
                    <li *ngFor="let number of skeletonItemNumbers">
                      <div class="car_box">
                        <div class="skeleton_main_photo"></div>
                        <div class="skeleton_model_year"></div>
                        <div class="skeleton_car_name"></div>
                        <div class="skeleton_copy"></div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-template>

    </div>

</app-layout>
